import React, { useState, useEffect } from 'react'
import Loader from "common/components/Loader";
import Header from "common/js/header/header";
import { toast, ToastContainer } from "react-toastify";
import { getCommonClsListSvc2, deleteCommonClsSvc, listSectionPeriodsSvc, getLstSubjectSvc, listEligibleTchSvc, saveCommonClsSvc2 } from "./CommonClsSvc.js";

import CommonClsSlider2 from './CommonClsSlider2.js';
const CommonClsCtrl2 = () => {
    const [loader, setLoader] = useState("none");
    const [opacity, setOpacity] = useState(1);
    const [commonClsId, setCommonClsId] = useState(0)
    const [daysOff, setDaysOff] = useState("0000000");
    const [periodsOff, setPeriodsOff] = useState("0000000000");
    const [subId, setSubId] = useState(0);
    const [rowIdx, setRowIdx] = useState(0);
    const [flgSlider, setFlgSlider] = useState(false);
    const [randNo, setRandNo] = useState(0);
    const [lstCommonCls, setLstCommonCls] = useState([]);
    const [tchId, setTchId] = useState(0);
    const [filters, setFilters] = useState({ sub: '', tch: '', cls: '' })
    const [lstFilteredCommonCls, setLstFilteredCommonCls] = useState([])
    useEffect(() => {
        getCommonClsList()
    }, [])

    function getCommonClsList() {
        getCommonClsListSvc2(commonClsListResponse)
    }
    useEffect(() => {
        const filtered = (lstCommonCls || []).filter((obj) => {
            const csvCls = obj.csvCls || "";
            const sub = obj.sub || "";
            const tch = obj.tch || "";
            return (
                csvCls.toString().toLowerCase().includes(filters.cls.toLowerCase()) &&
                sub.toLowerCase().includes(filters.sub.toLowerCase()) &&
                tch.toString().toLowerCase().includes(filters.tch.toLowerCase())
            );
        });
        setLstFilteredCommonCls(filtered);
    }, [lstCommonCls, filters]);

    function commonClsListResponse(data) {
        var obj = data;
        // console.log("obj in commonClsListResponse", obj);
        if (obj.status === "Success") {
            setLstCommonCls(obj.lstCommonCls)
            setLstFilteredCommonCls(obj.lstCommonCls)
        } else {
            toast.error(obj.message);
        }
    }
    function deleteCommonCls(pCommonClsId) {
        var r = window.confirm("Are you sure to delete the common/group classes?");
        if (r) {
            deleteCommonClsSvc(pCommonClsId, cbDeleteCommonCls)
        }
    }
    function cbDeleteCommonCls(data) {
        var obj = data;
        // console.log("obj in saveCommonClsResponse", obj);
        if (obj.status === "Success") {
            toast.success(obj.message)
            getCommonClsList()
        } else {
            toast.error(obj.message);
        }
    }
    function binaryToDays(binaryString) {
        // console.log("Method called: binaryToDays");
        // console.log("Parameters passed:", { binaryString });

        const daysOfWeek = ['M', 'T', 'W', 'T', 'F', 'S', 'S'];
        let result = '';

        for (let i = 0; i < binaryString.length; i++) {
            if (binaryString[i] === '1') {
                result += daysOfWeek[i];
            } else {
                result += "-"
            }
        }

        // console.log("Value to be returned:", result);
        return result;
    }


    const colgrp = <colgroup>
        {/* <col width="5%"></col> */}
        <col width="5%"></col>
        <col width="10%"></col>
        <col width="10%"></col>
        <col width="10%"></col>
        <col width="10%"></col>
        <col width="10%"></col>
        <col width="10%"></col>
    </colgroup>

    const handleFilterChange = (field, value) => {
        setFilters(prev =>
            ({ ...prev, [field]: value })
        )
    };

    function openSlider() {
        setFlgSlider(true)
    }
    function closeSlider() {
        setFlgSlider(false);
        setCommonClsId(0)
        generateRandomNo()
    }

    function generateRandomNo() {
        var lRandNo = Math.floor(Math.random() * 999999);
        setRandNo(lRandNo)
    }

    return (
        <div >
            <Header />
            <ToastContainer autoClose={3000} hideProgressBar />
            <Loader loader={loader} position="fixed" />
            <div className="col-md-12 col-xs-12 col-centered padding-remove"
                style={{
                    cursor: (loader === "none") ? 'pointer' : 'none',
                    pointerEvents: (loader === "none") ? 'auto' : 'none',
                    opacity: opacity
                }}>
            </div >
            <div className="col-sm-8 col-centered" style={{ marginTop: '2%' }}>
                <div className="col-sm-11" style={{ height: '100%' }}>

                    <div style={{ pointerEvents: loader === "none" ? "auto" : "none" }}>
                        <table className='tableLayout1'>

                            {colgrp}
                            <thead>
                                <tr>
                                    <th>Id</th>
                                    <th> <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        placeholder="Subject"
                                        value={filters.sub}
                                        onChange={(e) => handleFilterChange("sub", e.target.value)}
                                    />
                                    </th>
                                    <th> <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        placeholder="Teacher"
                                        value={filters.tch}
                                        onChange={(e) => handleFilterChange("tch", e.target.value)}
                                    />
                                    </th>
                                    <th> <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        placeholder="Classes"
                                        value={filters.cls}
                                        onChange={(e) => handleFilterChange("cls", e.target.value)}
                                    />
                                    </th>
                                    <th>Days Off</th>
                                    <th>Periods Off</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                        </table>
                        <div className='tablebodyWrapper'>
                            <table className='tableLayout'>
                                {colgrp}
                                <tbody>
                                    {lstFilteredCommonCls && lstFilteredCommonCls.map((obj, idx) => {
                                        return <tr key={idx} id={obj.commonClsId + '_' + idx}
                                            onClick={(e) => { setDaysOff(obj.daysOff); setPeriodsOff(obj.periodsOff); setTchId(obj.tchId); setCommonClsId(obj.commonClsId); setRowIdx(idx); setSubId(obj.subId); }}
                                            className={obj.commonClsId === commonClsId && idx === rowIdx ? "selected" : ""}>
                                            <td>{obj.commonClsId}</td>
                                            <td>{obj.sub}</td>
                                            <td className="text-left">{obj.tch}</td>
                                            <td className="text-left">{obj.csvCls}</td>
                                            <td className="text-center">{binaryToDays(obj.daysOff)}</td>
                                            <td className="text-center">{obj.periodsOff}</td>
                                            <td className="text-center" >
                                                <span className="glyphicon glyphicon-eye-open" onClick={() => openSlider()}>
                                                </span>
                                                <span className="glyphicon glyphicon-remove" onClick={() => deleteCommonCls(obj.commonClsId)}>
                                                </span>

                                            </td>
                                        </tr>
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div >
                </div>
                <div className="col-xs-1 ">
                    {/* <span title="Add" className="addIcon glyphicon glyphicon-plus-sign" onClick={() => { setSubId(0); setDaysOff('0000000'); setPeriodsOff('0000000000'); openSlider(commonClsId, 0) }}></span> */}
                    <span title="Add" className="addIcon glyphicon glyphicon-plus-sign" onClick={() => { setSubId(0); setDaysOff('0000000'); setPeriodsOff('0000000000'); openSlider(commonClsId, 0) }}></span>
                </div>
            </div >
            <div className="col-sm-4">
                {flgSlider && (
                    <div
                        style={{ width: "50%", display: flgSlider ? "block" : "none" }}
                        className=""
                    >
                        <button
                            onClick={() => closeSlider()}
                            type="button"
                            className="btn btn-info text-center btnCloseDiv"
                            style={{ right: "50%", zIndex: 1000 }}
                        >
                            <span
                                id="close"
                                title="Close Slider"
                                className="glyphicon glyphicon-remove"
                            ></span>
                        </button>
                        <CommonClsSlider2
                            key={'slider_' + subId}
                            subId={subId}
                            tchId={tchId}
                            commonClsId={commonClsId}
                            generateRandomNo={generateRandomNo}
                            getCommonClsList={getCommonClsList}
                            closeSlider={closeSlider}
                            daysOff={daysOff}
                            periodsOff={periodsOff}
                        />
                    </div>
                )}
            </div>
        </div>
    )
}

export default CommonClsCtrl2